// extracted by mini-css-extract-plugin
export var hideEditor = "_ei-2";
export var infoIcon = "_ei-3";
export var label = "_ei-1";
export var labelContainer = "_ei-0";
export var readonlyText = "_ei-4";